import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './ZoneForm.css';

const ZoneForm = ({ zone, onSave, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const isEditMode = !!zone;

  const formik = useFormik({
    initialValues: {
      name: zone?.name || '',
      hourly_rate: zone?.hourly_rate || 1.50
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Zone name is required'),
      hourly_rate: Yup.number()
        .positive('Hourly rate must be positive')
        .required('Hourly rate is required')
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        setError(null);
        
        await onSave(values);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <div className="zone-form">
      <h3>{isEditMode ? 'Edit Zone' : 'Add New Zone'}</h3>
      
      {error && <div className="form-error">{error}</div>}
      
      <form onSubmit={formik.handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Zone Name</label>
          <input
            id="name"
            name="name"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            placeholder="Enter zone name"
          />
          {formik.touched.name && formik.errors.name ? (
            <div className="field-error">{formik.errors.name}</div>
          ) : null}
        </div>

        {isEditMode && (
          <div className="form-group">
            <label htmlFor="code">Zone Code</label>
            <input
              id="code"
              type="text"
              value={zone.code}
              disabled
              className="disabled-input"
            />
            <div className="field-note">Zone code cannot be changed</div>
          </div>
        )}

        <div className="form-group">
          <label htmlFor="hourly_rate">Hourly Rate ($)</label>
          <input
            id="hourly_rate"
            name="hourly_rate"
            type="number"
            step="0.01"
            min="0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.hourly_rate}
          />
          {formik.touched.hourly_rate && formik.errors.hourly_rate ? (
            <div className="field-error">{formik.errors.hourly_rate}</div>
          ) : null}
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="cancel-button" 
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="save-button" 
            disabled={loading}
          >
            {loading ? 'Saving...' : isEditMode ? 'Update Zone' : 'Create Zone'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ZoneForm; 